import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

import { useConfiguration } from '../context/configurationContext';
import { useRouteConfiguration } from '../context/routeConfigurationContext';
import { clearedSearchParamsWithoutFiltersMapAndGeo } from '../containers/SearchPage/SearchPage.shared';
import { createResourceLocatorString } from './routes';

/**
 * Navigate to SearchPage with listing filters, geo/keyword search, and map bounds cleared
 * (same behavior as SearchPage "Clear filters").
 */
export const useNavigateToAllEventsSearch = () => {
  const history = useHistory();
  const location = useLocation();
  const config = useConfiguration();
  const routeConfiguration = useRouteConfiguration();

  return useCallback(() => {
    const cleared = clearedSearchParamsWithoutFiltersMapAndGeo(location.search, config);
    history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, { ...cleared, page: 1 }));
  }, [history, location.search, config, routeConfiguration]);
};
